import { render, staticRenderFns } from "./TypesPage.vue?vue&type=template&id=127d543b&"
import script from "./TypesPage.vue?vue&type=script&lang=js&"
export * from "./TypesPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports